<template>
  <!-- 回到顶部（全局通用） -->
  <a
    href="javascript:;"
    class="back-to-top"
    @click="scrollToTop"
    v-show="showTop"
  >
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
    </svg>
  </a>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// 控制显示隐藏（滚动大于300px显示）
const showTop = ref(false)

// 滚动监听
function onScroll() {
  showTop.value = window.scrollY > 300
}

// 回到顶部
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 44px;
  height: 44px;
  background: #0066cc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  z-index: 9999;
  transition: opacity 0.3s;
}
.back-to-top:hover {
  background: #005bb5;
}
</style>